import React from 'react';
import { DASH } from '../../utils/marketFormatters';

/**
 * Generic KPI card grid. Each item's `value` should already be formatted
 * (or DASH) by the caller — this component never does its own math.
 */
export const MarketKpiGrid = ({ items }) => (
  <div className="mk-kpi-grid">
    {items.map(item => (
      <div className="mk-kpi-card" key={item.label} title={item.tooltip || undefined}>
        <span className="mk-kpi-value">{item.value ?? DASH}</span>
        <span className="mk-kpi-label">{item.label}</span>
        {item.tooltip && <span className="mk-kpi-info" aria-hidden="true">ⓘ</span>}
      </div>
    ))}
  </div>
);

export default MarketKpiGrid;
